import {
  Dialog, DialogContent, useTheme,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { kebabCase } from 'change-case';
import { PartnerName } from '../../../../common/constants';
import PartnerEnrollmentDialogContent from './PartnerEnrollmentDialogContent';
import { ManufacturerDistributor } from './usePartnerConfigList';

type PartnerEnrollmentDialogProps = {
  updateEnrollmentDialogOpenState: (event: boolean) => void;
  updateConfirmationDialogOpenState?: (event: boolean) => void;
  confirmationDialogOpenState?: boolean;
  partnerName: PartnerName,
  partnerCode: string,
  partnerId: string,
  partnerLogoUrl: string,
  partnerLogoImageWidth: number,
  supportsExistingAccountFlow: boolean,
  supportsManufacturerFlow: boolean,
  manufacturerDistributors: ManufacturerDistributor[] | null
  hasExtraExistingAccQuestion?: boolean,
};

export function PartnerEnrollmentDialog({
  updateEnrollmentDialogOpenState,
  updateConfirmationDialogOpenState,
  confirmationDialogOpenState,
  partnerName,
  partnerCode,
  partnerId,
  partnerLogoUrl,
  partnerLogoImageWidth,
  supportsExistingAccountFlow,
  manufacturerDistributors,
  hasExtraExistingAccQuestion,
  supportsManufacturerFlow,
}: PartnerEnrollmentDialogProps) {
  const theme = useTheme();
  const [localEnrollmentDialogOpenState, updateLocalEnrollmentDialogOpenState] = useState(true);

  const optionalCardStyle = () => ({
    width: '100%',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    height: 'fit-content',
    border: theme.spacing(0),
  } as const);
  const onDialogClose = () => {
    // reset all to default states
    updateLocalEnrollmentDialogOpenState(false);
    updateEnrollmentDialogOpenState(false);
    updateConfirmationDialogOpenState?.(false);
  };

  return (
    <>
      <Dialog
        open={localEnrollmentDialogOpenState}
        keepMounted
        onClose={onDialogClose}
        aria-describedby={`${kebabCase(partnerName)}-enrollment-dialog`}
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            borderRadius: theme.spacing(2.25),
            [theme.breakpoints.down('lg')]: {
              p: theme.spacing(0),
            },
          },
        }}
      >
        <DialogContent
          sx={{ paddingRight: theme.spacing(3) }}
        >
          <IconButton
            aria-label="close"
            onClick={onDialogClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.brand.primary,
            }}
          >
            <CloseIcon />
          </IconButton>
          <PartnerEnrollmentDialogContent
            optionalCardStyle={optionalCardStyle}
            updateEnrollmentDialogOpenState={updateEnrollmentDialogOpenState}
            updateConfirmationDialogOpenState={updateConfirmationDialogOpenState}
            confirmationDialogOpenState={confirmationDialogOpenState}
            partnerId={partnerId}
            partnerLogoUrl={partnerLogoUrl}
            partnerName={partnerName}
            partnerCode={partnerCode}
            partnerLogoImageWidth={partnerLogoImageWidth}
            supportsExistingAccountFlow={supportsExistingAccountFlow}
            manufacturerDistributors={manufacturerDistributors}
            supportsManufacturerFlow={supportsManufacturerFlow}
            hasExtraExistingAccQuestion={hasExtraExistingAccQuestion}
          />
        </DialogContent>
      </Dialog >
    </>
  );
}
